'use strict';

var amber$1 = require('../../../../_virtual/amber.js_commonjs-exports.js');

Object.defineProperty(amber$1.__exports, "__esModule", {
  value: true
});
exports["default"] = amber$1.__exports.default = void 0;
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
var _default = amber;
exports["default"] = amber$1.__exports.default = _default;

module.exports = exports["default"];
